// src/protocols/debts.js — справка задължения + уведомления за печат (Фаза 3.2).

import { el, clear, input } from '../shared/dom.js';
import { dfmt } from '../shared/format.js';
import { toast } from '../shared/toast.js';
import { api } from '../shared/api.js';
import { regHead, regFilters, regField, regCount, REG_TABLE } from '../shared/register.js';
import { state, cq, activeCompanyObj } from '../shared/state.js';
import { esc, printHTML } from './print.js';

function _money(n){ n=Math.round((Number(n)||0)*100)/100; var p=n.toFixed(2).split('.'); p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,' '); return p[0]+'.'+p[1]+' €'; }

function _overdue(due){ if(!due) return 0; var d=new Date(due+'T00:00:00'); if(isNaN(d)) return 0; var t=new Date(); t.setHours(0,0,0,0); var diff=Math.floor((t-d)/86400000); return diff>0?diff:0; }

function _join(arr,sep){ return arr.filter(Boolean).join(sep||' · '); }

var _NOTICE_CSS='*{box-sizing:border-box}html,body{margin:0;background:#fff}'
+'body{font-family:"Segoe UI",Arial,Helvetica,sans-serif;color:#1c2733;font-size:12.5px;line-height:1.45;-webkit-print-color-adjust:exact;print-color-adjust:exact}'
+'.page{width:210mm;min-height:290mm;margin:0 auto;background:#fff;padding:11mm 14mm 14mm;position:relative}'
+'.page+.page{page-break-before:always}'
+'.head{display:flex;justify-content:space-between;align-items:flex-start;gap:14px;border-bottom:2px solid #15324e;padding-bottom:9px}'
+'.brand{display:flex;gap:14px;align-items:center}'
+'.logo-img{max-height:58px;max-width:140px;object-fit:contain}'
+'.sender-name{font-size:19px;font-weight:800;color:#15324e;letter-spacing:-.2px}'
+'.sender-meta{font-size:11.5px;color:#5b6b7a;margin-top:3px;line-height:1.5}'
+'.doc-date{text-align:right;font-size:12px;color:#5b6b7a;white-space:nowrap}.doc-date b{display:block;color:#1c2733;font-size:13px;margin-top:2px}'
+'.to{margin:10px 0 3px}.to-label{font-size:11px;letter-spacing:.14em;color:#5b6b7a;text-transform:uppercase}'
+'.to-name{font-size:15px;font-weight:700;margin-top:2px}.to-meta{font-size:12px;color:#5b6b7a}'
+'.title{margin:10px 0 3px;text-align:center}.title h1{margin:0;font-size:15px;letter-spacing:.06em;color:#15324e;text-transform:uppercase}'
+'.title .sub{font-size:11.5px;color:#1f8a80;letter-spacing:.18em;text-transform:uppercase;margin-top:4px}'
+'.rule{height:3px;width:64px;background:#c39a3f;margin:6px auto 0;border-radius:2px}'
+'p{margin:5px 0}p.lead{margin:8px 0 5px}'
+'table{width:100%;border-collapse:collapse;margin:6px 0 4px;font-size:11.5px}'
+'thead th{background:#15324e;color:#fff;font-weight:600;text-align:left;padding:5px 8px;font-size:10.5px}'
+'thead th.num{text-align:right}'
+'tbody td{padding:4px 8px;border-bottom:1px solid #dbe3ea;font-variant-numeric:tabular-nums}tbody td.num{text-align:right}'
+'tbody tr:nth-child(even){background:#fafcfc}.ovr{color:#b23b3b;font-weight:600}'
+'tfoot td{padding:6px 8px;font-weight:800;color:#15324e;border-top:2px solid #15324e;font-size:12.5px}tfoot td.num{text-align:right;font-variant-numeric:tabular-nums}'
+'tr.msub td{background:#f3f7f8;font-weight:700;color:#15324e;border-bottom:2px solid #dbe3ea}'
+'tfoot tr.mrow td{font-weight:600;font-size:11.5px;color:#5b6b7a;border-top:1px solid #dbe3ea;padding:4px 8px}'
+'.callout{background:#f3f7f8;border:1px solid #dbe3ea;border-left:4px solid #1f8a80;border-radius:8px;padding:10px 16px;margin:10px 0;display:flex;justify-content:space-between;align-items:center}'
+'.callout .lbl{font-size:12px;color:#5b6b7a}.callout .val{font-size:22px;font-weight:800;color:#15324e;font-variant-numeric:tabular-nums}'
+'.pay{margin:7px 0;border:1px dashed #1f8a80;border-radius:8px;padding:7px 12px;background:#f6fbfa}'
+'.pay .row{display:flex;gap:8px;font-size:11.5px;margin:1px 0}.pay .k{color:#5b6b7a;min-width:82px}.pay .v{font-weight:600}'
+'.soft{font-size:10.5px;color:#5b6b7a;font-style:italic;margin:8px 0}'
+'.sign{margin-top:14px;display:flex;justify-content:space-between;align-items:flex-end}.sign .with{font-size:13px}'
+'.sign .line{width:210px;border-top:1px solid #1c2733;text-align:center;padding-top:5px;font-size:11.5px;color:#5b6b7a}'
+'.foot{position:absolute;left:18mm;right:18mm;bottom:12mm;border-top:1px solid #dbe3ea;padding-top:8px;font-size:10px;color:#9aa7b3;text-align:center}'
+'@media print{.page{margin:0;padding:16mm 16mm 20mm}}';


// Краят на таблицата: САМО „Общо дължимо" (Макс махна месечното обобщение —
// междинните тотали в списъка вече казват колко е всеки месец).
export function _monthSummaryRows(g){
  return '<tr><td colspan="4">Общо дължимо</td><td class="num">'+_money(g.sum)+'</td></tr>';
}

// Редовете на таблицата с фактурите, групирани по месец на издаване:
// фактурите на месеца, после ред „Общо за <месец>", после следващият месец.
// При един-единствен месец междинният тотал се пропуска (би дублирал общото).
export function _invoiceRowsWithSubtotals(g){
  var sorted=(g.list||[]).slice().sort(function(a,b){ return String(a.issue_date||'').localeCompare(String(b.issue_date||'')); });
  var monthsCnt={}; sorted.forEach(function(i){ monthsCnt[(i.issue_date||'').slice(0,7)||'без дата']=1; });
  var withSubs=Object.keys(monthsCnt).length>=2;
  var html='', curYm=null, msum=0;
  function subRow(){ if(curYm==null||!withSubs) return; html+='<tr class="msub"><td colspan="4">Общо за '+esc(_monthLabel(curYm))+'</td><td class="num">'+_money(msum)+'</td></tr>'; }
  sorted.forEach(function(i){
    var ym=(i.issue_date||'').slice(0,7)||'без дата';
    if(ym!==curYm){ subRow(); curYm=ym; msum=0; }
    msum+=Number(i.total)||0;
    var od=_overdue(i.due_date);
    html+='<tr><td>№ '+esc(i.number)+'</td><td>'+esc(i.issue_date?dfmt(i.issue_date):'—')+'</td><td>'+esc(i.due_date?dfmt(i.due_date):'—')+'</td>'
      +'<td class="num">'+(od>0?'<span class="ovr">'+od+' дни</span>':'—')+'</td>'
      +'<td class="num">'+_money(i.total)+'</td></tr>';
  });
  subRow();
  return html;
}

function _noticePage(g, comp, logoImg, dstr){
  var c=g.contact||{};
  var senderMeta=_join([
    _join([comp.eik?'ЕИК '+esc(comp.eik):'', comp.vat_number?'ДДС № '+esc(comp.vat_number):'']),
    _join([comp.city?'гр. '+esc(comp.city):'', comp.address?esc(comp.address):''], ', '),
    _join([comp.phone?'тел. '+esc(comp.phone):'', comp.email?esc(comp.email):''])
  ], '<br>');
  var toMeta=_join([ c.eik?'ЕИК '+esc(c.eik):'', _join([c.city?'гр. '+esc(c.city):'', c.address?esc(c.address):''], ', ') ]);
  var rows=_invoiceRowsWithSubtotals(g);
  // esc() и на логото (преглед 17.09.2026): това беше ЕДИНСТВЕНАТА
  // конкатенация в печата без екраниране — кавичка в записа пренаписваше
  // документа. Сървърът вече валидира стриктно; тук е вторият колан.
  var brand=(logoImg?'<img class="logo-img" src="'+esc(logoImg)+'" alt="">':'')
    +'<div><div class="sender-name">'+esc(comp.name||'')+'</div>'+(senderMeta?'<div class="sender-meta">'+senderMeta+'</div>':'')+'</div>';
  var payRows=_join([
    comp.iban?'<div class="row"><span class="k">IBAN</span><span class="v">'+esc(comp.iban)+'</span></div>':'',
    comp.bank?'<div class="row"><span class="k">Банка</span><span class="v">'+esc(comp.bank)+'</span></div>':'',
    '<div class="row"><span class="k">Основание</span><span class="v">Плащане по посочените фактури</span></div>'
  ], '');
  var payBox=(comp.iban||comp.bank)?('<div class="pay">'+payRows+'</div>'):'';
  var signName=comp.mol?'<br><b>'+esc(comp.mol)+'</b>':'';
  return '<div class="page">'
    +'<div class="head"><div class="brand">'+brand+'</div><div class="doc-date">Изготвено на<b>'+dstr+' г.</b></div></div>'
    +'<div class="to"><div class="to-label">До</div><div class="to-name">'+esc(g.name)+'</div>'+(toMeta?'<div class="to-meta">'+toMeta+'</div>':'')+'</div>'
    +'<div class="title"><h1>Уведомление за неизплатени задължения</h1><div class="rule"></div></div>'
    +'<p class="lead">Уважаеми партньори,</p>'
    +'<p>Уведомяваме Ви, че съгласно счетоводната ни отчетност към <b>'+dstr+' г.</b> имате незаплатени задължения към '+esc(comp.name||'нашата фирма')+' по следните фактури:</p>'
    +'<table><thead><tr><th>№ Фактура</th><th>Издадена</th><th>Падеж</th><th class="num">Просрочие</th><th class="num">Сума</th></tr></thead>'
    +'<tbody>'+rows+'</tbody><tfoot>'+_monthSummaryRows(g)+'</tfoot></table>'
    +payBox
    +'<p class="soft">Ако плащането вече е извършено, моля приемете нашите благодарности и не се съобразявайте с настоящото уведомление.</p>'
    +'<div class="sign"><div class="with">С уважение,'+signName+'<br><span style="color:#5b6b7a;font-size:12px">'+esc(comp.name||'')+'</span></div><div class="line">подпис / печат</div></div>'
    +'<div class="foot">'+_join([esc(comp.name||''), comp.eik?'ЕИК '+esc(comp.eik):'', 'Документът е генериран автоматично от CRM системата.'])+'</div>'
    +'</div>';
}

async function printDebtNotices(groups){
  var comp=activeCompanyObj()||{};
  var logoImg='';
  if(comp.logo_set && comp.id){ try{ var r=await api('/companies/'+comp.id+'/logo'); logoImg=(r&&r.logo)||''; }catch(e){} }
  var now=new Date(); var dstr=('0'+now.getDate()).slice(-2)+'.'+('0'+(now.getMonth()+1)).slice(-2)+'.'+now.getFullYear();
  var pages=groups.map(function(g){ return _noticePage(g, comp, logoImg, dstr); }).join('');
  var html='<!DOCTYPE html><html lang="bg"><head><meta charset="utf-8"><title>Уведомления за задължения</title><style>'+_NOTICE_CSS+'</style></head><body>'+pages+'</body></html>';
  printHTML(html);
}

const _BG_MONTHS=['януари','февруари','март','април','май','юни','юли','август','септември','октомври','ноември','декември'];
function _monthLabel(ym){ var p=String(ym).split('-'); if(p.length<2) return String(ym); var m=Number(p[1]); return (_BG_MONTHS[m-1]||p[1])+' '+p[0]; }

export async function view(host){
  clear(host);
  let invoices=[], contacts=[];
  try{ const rr = await Promise.all([api('/invoices'+cq()), api('/contacts'+cq())]); invoices=rr[0]; contacts=rr[1]; }catch(e){ toast(e.message,true); return; }
  const cName=function(id){ var c=contacts.find(function(x){return x.id===id;}); return c?c.name:'(без клиент)'; };
  const unpaid = invoices.filter(function(i){ return i.company_id===state().activeCompany && i.status!=='paid'; });
  var groups={};
  unpaid.forEach(function(i){ var k=i.contact_id||0; if(!groups[k]){ var _c=contacts.find(function(x){return x.id===i.contact_id;}); groups[k]={id:k, name:_c?_c.name:'(без клиент)', contact:_c||null, count:0, sum:0, list:[], byMonth:{}}; } groups[k].count++; groups[k].sum+=Number(i.total)||0; groups[k].list.push(i);
    // Разбивка по месец на ИЗДАВАНЕ — при месечни такси това е „кой месец
    // не е платен". Фактура без дата отива в „без дата".
    var ym=(i.issue_date||'').slice(0,7)||'без дата';
    if(!groups[k].byMonth[ym]) groups[k].byMonth[ym]={count:0,sum:0};
    groups[k].byMonth[ym].count++; groups[k].byMonth[ym].sum+=Number(i.total)||0; });
  var rows=Object.keys(groups).map(function(k){return groups[k];}).sort(function(a,b){return b.sum-a.sum;});
  var selected={}; rows.forEach(function(g){ selected[g.id]=true; });
  var expanded={}; // кои клиенти са разгънати по месеци
  const fmt=function(n){ return (Math.round(n*100)/100).toFixed(2)+' €'; };
  const panel=el('div',{class:'panel'});
  const search=input({type:'search', placeholder:'Търси клиент…', 'aria-label':'Търси клиент'});
  const tbodyEl=el('tbody');
  // Броячът над таблицата (като в „Доставки"): колко клиенти се виждат + избраната сума.
  const countLbl=regCount();
  var shown=0;
  function recount(){ var tot=0,tc=0; rows.forEach(function(g){ if(selected[g.id]){ tot+=g.sum; tc+=g.count; } }); countLbl.set(shown, rows.length, search.value); countLbl.appendChild(document.createTextNode(' · Избрано: '+tc+' неплатени · Общо дължимо: '+fmt(tot))); }
  function draw(){ clear(tbodyEl); var q=(search.value||'').toLowerCase(); shown=0; rows.forEach(function(g){ if(q && g.name.toLowerCase().indexOf(q)===-1) return; shown++;
    var cb=el('input',{type:'checkbox', 'aria-label':'Избери '+g.name}); cb.checked=!!selected[g.id]; cb.addEventListener('change',function(){ selected[g.id]=cb.checked; recount(); });
    var months=Object.keys(g.byMonth).sort().reverse();
    var toggle=el('button',{class:'btn sm ghost', type:'button', style:'padding:2px 8px;min-width:30px',
      'aria-expanded': expanded[g.id]?'true':'false', 'aria-label':'Разбивка по месеци за '+g.name,
      text: expanded[g.id]?'▾':'▸',
      onClick:function(){ expanded[g.id]=!expanded[g.id]; draw(); }});
    tbodyEl.appendChild(el('tr',{}, el('td',{},cb), el('td',{style:'font-weight:600'}, toggle, ' ', g.name), el('td',{class:'num'}, String(g.count)), el('td',{class:'num'}, fmt(g.sum))));
    if(expanded[g.id]){ months.forEach(function(ym){ var m=g.byMonth[ym];
      tbodyEl.appendChild(el('tr',{class:'debt-month'},
        el('td',{}),
        el('td',{style:'padding-left:42px;color:var(--muted)'}, _monthLabel(ym)),
        el('td',{class:'num',style:'color:var(--muted)'}, String(m.count)),
        el('td',{class:'num',style:'color:var(--muted)'}, fmt(m.sum)))); }); }
  }); recount(); }
  search.addEventListener('input', draw);
  const printBtn=el('button',{class:'btn sm', text:'Печат / PDF', onClick:function(){ var sel=rows.filter(function(g){return selected[g.id];}); if(!sel.length){ toast('Изберете поне един клиент.', true); return; } printDebtNotices(sel); }});
  // „Печат / PDF" е основното действие на справката — вдясно на реда със
  // заглавието, както „+ Нов…" в другите списъци; без неплатени няма какво да се печата.
  panel.appendChild(regHead('Справка текущи задължения', [], rows.length ? printBtn : null));
  if(!rows.length){ panel.appendChild(el('p',{style:'color:var(--muted)', text:'Няма неплатени фактури за тази фирма.'})); host.appendChild(panel); return; }
  panel.appendChild(regFilters(regField('Клиент', search, 'l')));
  panel.appendChild(countLbl);
  const table=el('table',{class:REG_TABLE}, el('thead',{},el('tr',{}, el('th',{style:'width:30px'}), el('th',{text:'Клиент'}), el('th',{class:'num',text:'Неплатени'}), el('th',{class:'num',text:'Дължимо'}))), tbodyEl);
  panel.appendChild(table);
  host.appendChild(panel);
  draw();
}
